











import {defineComponent, PropType} from "@vue/composition-api"
import {useGetters} from "vuex-composition-helpers"
import StudyItem from "@/apps/MyStudyChoiceFavoritesWidget/components/Studies/StudyItem.vue"
import HeadingCount from "@/apps/MyStudyChoiceFavoritesWidget/components/Modal/HeadingCount.vue"
import { IStudies } from "@/shared/models/api/study-choice-studies-model"

export default defineComponent({
    name: "ScrollableModalContainer",
    components: {
        StudyItem, 
        HeadingCount
    },
    props: {
        searchResults: {
            type: [] as PropType<IStudies>,
            required: true,
            default: ""
        }
    },
    setup: () => {
        const {config} = useGetters([
            'config'
        ]);

        return {
            config
        }
    }
})
